import React, { ReactNode } from 'react'
import clsx from 'clsx'

interface ExternalLinkProps {
  href: string
  children?: ReactNode
  className?: string
  target?: '_top' | '_blank'
}

export const ExternalLink = ({
  href,
  children,
  className,
  target = '_blank',
}: ExternalLinkProps) => {
  return (
    <a
      href={href}
      target={target}
      rel="noopener noreferrer"
      className={clsx(
        'text-foreground-action-secondary inline font-medium hover:underline',
        className
      )}
    >
      {children}
    </a>
  )
}
